/**
 * Created by TTND on 1/23/2018.
 */
import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Slider from 'react-slick'

import ImageDesignation from '../ImageDesignation'
import { openPopup } from '../../../general/Modal/action'
import { MODALS } from '../../../general/Modal/constants'
import './style.scss'

@connect((state) => {
  return {}
}, (dispatch) => {
  return {
    ...bindActionCreators({openPopup}, dispatch),
  }
})


export default class SubTabContent extends React.Component {

  render () {
    let {item, openPopup, trusteesListContent, tabClass = ''} = this.props
    const settings = {
      swipe: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      speed: 500,
      autoplaySpeed: 3000,
      draggable: true,
      infinite: false,
      arrows: true,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        }
      },
        {
          breakpoint: 1170,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
          }
        }]
    }

    let sliderList = trusteesListContent && (trusteesListContent.trusteesList || trusteesListContent.committeeList)  ? trusteesListContent.trusteesList ?trusteesListContent.trusteesList:  trusteesListContent.committeeList: []
    return (
      <div className={tabClass != '' ? `container-930 about-us-subtab ${tabClass}` : 'container-930 about-us-subtab'}>
        {(item && (item.image || item.name || item.position)) && <ImageDesignation item={{
          ...item, 
          image: {
            ...item.image, 
            alt: item.image.alt || item.name,
            desc: item.image.desc || item.position,
          }}}
        />}
        {item && item.body && <div className="description" dangerouslySetInnerHTML={{__html: item.body}}></div>}
        {item && item.description &&
        <div className="description" dangerouslySetInnerHTML={{__html: item.description}}></div>}
        {trusteesListContent && trusteesListContent.body &&
        <div className="description" dangerouslySetInnerHTML={{__html: trusteesListContent.body}}></div>}
        {trusteesListContent && trusteesListContent.title &&
        <h3 className="trustee-list" dangerouslySetInnerHTML={{__html: trusteesListContent.title}}/>}
        <div className="clearfix">
            {sliderList && sliderList.length >0 && <Slider {...settings}>{sliderList && sliderList.length > 0
          && sliderList.map((content, idx) => {
            return (<div className="col-3 align-center" key={idx}>
              {(content.image || content.name || content.position) && <ImageDesignation item={content}/>}
              <span className="blue-link"
                    onClick={() => {
                      openPopup(MODALS.TRUSTEE_DETAIL, {
                        modalClass: 'trustee-detail', heading: '',
                        subHeading: '', modalData: {trusteesListContent}, selectedTrustee: idx
                      })
                    }}
              >View profile</span>
            </div>)
          })}
          </Slider>}
        </div>
      </div>
    )
  }
}
